import { VHost } from '@plek-projects/shared-resources/New';
import { noop } from 'lodash';
import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { MERGED_VHOST } from '../consts/VHost';
import { createProxyHandler } from '../util/createProxyHandler';

export const VhostContext = createContext({ vhost: window.vhostObj, setVhost: noop });

export const VhostProvider = ({ children }: { children: React.ReactNode }) => {
	const [vhost, setContextVhost] = useState(MERGED_VHOST);

	const setVhost = useCallback((vhost) => {
		setContextVhost(vhost);
		window._vhostObj = vhost;
	}, []);

	useEffect(() => {
		// Initialize our true hidden value and create our proxy
		window._vhostObj = MERGED_VHOST;
		window.vhostObj = new Proxy(window._vhostObj, createProxyHandler<VHost.VHostFrontend>(setContextVhost));
	}, []);

	const value = useMemo(() => ({ vhost, setVhost }), [vhost, setVhost]);

	return <VhostContext.Provider value={value}>{children}</VhostContext.Provider>;
};
